import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as rateAction from '../../../../actions/rateAction';
import Rates from './Rates';
import * as hotelActions from './../../../../actions/hotelAction';

const mapStateToProps = state => {
    return {
        rateState: state.rateReducer,
        hotelState: state.hotelReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListRates: (filters) => {
            dispatch(rateAction.getListRates(filters))
        },
        sortRates: (rates, filters) => dispatch(rateAction.sortRate(rates, filters)),
        syncRates: (hotelId, rateCodes, isRefresh) => dispatch(rateAction.syncRates(hotelId, rateCodes, isRefresh)),
        updateRateActive: (obj) => dispatch(rateAction.updateRateActive(obj)),
        usageStatus: (rates, filters) => dispatch(rateAction.usageStatus(rates, filters)),
        syncRateLanguage: (obj) => dispatch(rateAction.syncRateLanguage(obj)),
        getHotelDetail: (id) => dispatch(hotelActions.getHotelDetail(id)),
        updateRateExtend: (obj) => dispatch(rateAction.updateRateExtend(obj))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Rates));
